import { CreateSecretInput30co61ns422r9 as CreateSecretInput } from './schema/type/CreateSecretInput.mjs';
import { CreateSecretMutation3m5frrt825225 as CreateSecretMutation } from './schema/CreateSecretMutation.mjs';
import { Dispatcher3f3rv68jjbf7x as Dispatcher } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/secret/CreateSecretCommand.mjs';
import { GqlTrait2wtoeyl3yfalb as GqlTrait } from './gql/GqlTrait.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Secret2t4auo9luo6wh as Secret } from '../../../../../Coupling-libraries-model/com/zegreatrob/coupling/model/party/Secret.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function createSecretInput($this, command) {
  return new (CreateSecretInput())(command.o2l_1, command.p2l_1);
}
function *perform(command, $completion) {
  var tmp0_safe_receiver = (yield* this.r6t(new (CreateSecretMutation())(createSecretInput(this, command)), $completion)).b42_1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k6c_1;
  return tmp1_safe_receiver == null ? null : toDomain(tmp1_safe_receiver);
}
var SdkCreateSecretCommandDispatcherClass;
function SdkCreateSecretCommandDispatcher() {
  if (SdkCreateSecretCommandDispatcherClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'SdkCreateSecretCommandDispatcher', VOID, VOID, [Dispatcher(), GqlTrait()], [1]);
    SdkCreateSecretCommandDispatcherClass = $;
  }
  return SdkCreateSecretCommandDispatcherClass;
}
function toDomain(_this__u8e3s4) {
  return to(new (Secret())(_this__u8e3s4.l6c_1, _this__u8e3s4.m6c_1, _this__u8e3s4.n6c_1, _this__u8e3s4.o6c_1), _this__u8e3s4.p6c_1);
}
//region block: exports
export {
  SdkCreateSecretCommandDispatcher as SdkCreateSecretCommandDispatcher1ii7hep4t7p2,
  perform as perform229jxw4jfq0sa,
};
//endregion

//# sourceMappingURL=SdkCreateSecretCommandDispatcher.mjs.map
